<template>
    <div class="stars band-review__stars">
        <span class="icon-full-star" v-for="n in fullStars" :key="'fullStar' + n"></span>
        <span class="icon-half-star" v-for="n in halfStars" :key="'halfStar' + n"></span>
    </div>
</template>

<script>
    const starIncreasePercentage = 40;
    const roundToMax = 4.1;
    export default {
        props: {
            maxStars: {
                default: 5,
                type: Number,
            },
            rating: Number,
            roundStars: {
                default: true,
                type: Boolean,
            }
        },

        computed: {
            roundedRating() {
              const divider = +(10 / (starIncreasePercentage / 10)).toFixed(1);
              const addittion = +((this.maxStars - this.rating) / divider).toFixed(1);

              const rounded = +(this.rating + addittion).toFixed(4);

              if (rounded >= this.maxStars || rounded >= roundToMax) {
                return this.maxStars;
              }

              return rounded;
            },
            getCurrentRating() {
                return this.roundStars ? this.roundedRating : this.rating;
            },
            fullStars() {
                const fullAmountOfStars = Math.floor(this.getCurrentRating);
                return fullAmountOfStars > this.maxStars ? this.maxStars : fullAmountOfStars;
            },

            halfStars() {
                if (this.fullStars === this.maxStars) {
                    return 0;
                }

                return this.getCurrentRating % 1 > 0 ? 1 : 0;
            }
        }
    };
</script>
